var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAivent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 189,
    height: 189,
    viewBox: "0 0 189 189",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#06addf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1ad3a6"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_432",
    "data-name": "Group 432",
    transform: "translate(-846.29 -2642.485)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_431",
    "data-name": "Group 431",
    transform: "translate(560 6)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19",
    "data-name": "Ellipse 19",
    cx: 94.5,
    cy: 94.5,
    r: 94.5,
    transform: "translate(286.29 2636.485)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "download_8_",
    "data-name": "download (8)",
    transform: "translate(730.44 2525.035)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1324",
    "data-name": "Path 1324",
    d: "M248.288,175.95H172.41a9.53,9.53,0,0,0-9.52,9.522v21.687a9.531,9.531,0,0,0,9.52,9.521h75.878a9.531,9.531,0,0,0,9.521-9.521V185.472A9.531,9.531,0,0,0,248.288,175.95Zm6.248,31.209a6.255,6.255,0,0,1-6.249,6.249H172.412a6.254,6.254,0,0,1-6.247-6.249V185.472a6.255,6.255,0,0,1,6.247-6.249h75.878a6.255,6.255,0,0,1,6.249,6.249v21.687Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1325",
    "data-name": "Path 1325",
    d: "M217.923,204.51H193.215a4.2,4.2,0,0,0-4.193,4.2v19.62a4.2,4.2,0,0,0,4.193,4.187h24.708a4.2,4.2,0,0,0,4.192-4.187V208.71A4.2,4.2,0,0,0,217.923,204.51Zm-24.708,3.274h24.708a.925.925,0,0,1,.919.927v1.624H192.3v-1.624a.924.924,0,0,1,.92-.926Zm6.717,6.878v2.219h-7.638v-3.273h7.852a4.128,4.128,0,0,0-.214,1.054Zm-7.638,5.491h7.638v2.215a4.2,4.2,0,0,0,.214,1.058h-7.852Zm10.91,2.215v-7.706a1.057,1.057,0,0,1,1.058-1.054h2.612a1.057,1.057,0,0,1,1.057,1.054v7.706a1.058,1.058,0,0,1-1.057,1.058h-2.612A1.058,1.058,0,0,1,203.2,222.368Zm8,0v-2.215h7.638v3.273H210.99a4.117,4.117,0,0,0,.214-1.058Zm0-5.488v-2.219a4.142,4.142,0,0,0-.213-1.054h7.85v3.273Zm6.718,12.363H193.214a.917.917,0,0,1-.92-.913V226.7h26.548v1.63a.918.918,0,0,1-.919.913Z",
    transform: "translate(-20.312 -22.2)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1326",
    "data-name": "Path 1326",
    d: "M443.277,204.51H418.569a4.2,4.2,0,0,0-4.195,4.2v19.62a4.2,4.2,0,0,0,4.195,4.187h24.708a4.2,4.2,0,0,0,4.195-4.187V208.71A4.2,4.2,0,0,0,443.277,204.51Zm-24.708,3.274h24.708a.925.925,0,0,1,.92.927v1.624H417.649v-1.624a.924.924,0,0,1,.919-.926Zm6.716,6.878v2.219h-7.636v-3.273h7.85a4.128,4.128,0,0,0-.214,1.054Zm0,5.491v2.215a4.2,4.2,0,0,0,.214,1.058h-7.85v-3.273Zm3.273,2.215v-7.706a1.056,1.056,0,0,1,1.058-1.054h2.612a1.057,1.057,0,0,1,1.059,1.054v7.706a1.058,1.058,0,0,1-1.059,1.058h-2.612A1.058,1.058,0,0,1,428.558,222.368Zm8,0v-2.215H444.2v3.273h-7.853a4.192,4.192,0,0,0,.214-1.058Zm0-5.488v-2.219a4.143,4.143,0,0,0-.214-1.054H444.2v3.273Zm6.718,12.363H418.568a.917.917,0,0,1-.919-.913V226.7H444.2v1.63a.922.922,0,0,1-.923.913Z",
    transform: "translate(-195.479 -22.2)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1327",
    "data-name": "Path 1327",
    d: "M352.332,237.394a3.956,3.956,0,0,0-6.631,0l-3.895,6.744a3.827,3.827,0,0,0,3.318,5.741h7.784a3.826,3.826,0,0,0,3.316-5.741Zm1.06,8.934a.54.54,0,0,1-.484.278h-7.785a.539.539,0,0,1-.485-.282.532.532,0,0,1,0-.55l3.895-6.744a.555.555,0,0,1,.962,0l3.894,6.748a.525.525,0,0,1,0,.55Z",
    transform: "translate(-138.667 -46.363)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1328",
    "data-name": "Path 1328",
    d: "M272.52,407.155a1.637,1.637,0,0,0-1.637,1.637v3.637a4.182,4.182,0,0,1-8.365,0v-22.55a1.637,1.637,0,0,0-3.274,0v22.55a7.456,7.456,0,0,0,14.913,0v-3.637a1.635,1.635,0,0,0-1.636-1.637Z",
    transform: "translate(-74.896 -165.015)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1329",
    "data-name": "Path 1329",
    d: "M200.65,388.24a1.637,1.637,0,0,0-1.637,1.637v32.732a4.182,4.182,0,1,1-8.365,0v-3.634a1.637,1.637,0,1,0-3.274,0v3.634a7.456,7.456,0,0,0,14.913,0V389.877a1.637,1.637,0,0,0-1.637-1.637Z",
    transform: "translate(-19.031 -165.014)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1330",
    "data-name": "Path 1330",
    d: "M510.93,394.094a1.636,1.636,0,0,0-1.637,1.637v3.634a4.184,4.184,0,0,1-8.369,0V376.817a1.637,1.637,0,1,0-3.274,0v22.548a7.457,7.457,0,0,0,14.914,0v-3.634a1.631,1.631,0,0,0-1.635-1.636Z",
    transform: "translate(-260.211 -154.862)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1331",
    "data-name": "Path 1331",
    d: "M439.077,375.175a1.636,1.636,0,0,0-1.637,1.637v32.73a4.183,4.183,0,1,1-8.366,0v-3.636a1.637,1.637,0,1,0-3.274,0v3.636a7.456,7.456,0,1,0,14.911,0V376.81a1.634,1.634,0,0,0-1.635-1.636Z",
    transform: "translate(-204.36 -154.857)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAivent);
export default __webpack_public_path__ + "static/media/aivent.d12c721e2bada787786ce09a690bac4c.svg";
export { ForwardRef as ReactComponent };